/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import Flow from '@flowjs/ng-flow/dist/ng-flow-standalone.min';
import UrlHandler from './url.handler';

/*@ngInject*/
export default function AppRun($rootScope, $window, $injector, $location, $log, $state, $mdDialog, $filter, loginService, $interval, userService, $translate, toast) {

    $window.Flow = Flow;
    var unauthorizedDialog = null;
    var forbiddenDialog = null;

    var refreshInterval = null;

    // UI checks token expiration every 10 minutes
    const REFRESH_INTERVAL = 10 * 60 * 1000;
    // Buffer of 10 additional minutes to trigger early token refresh
    const TOKEN_BUFFER_MS = 10 * 60 * 1000;

    initWatchers();
    
    function initWatchers() {
        $rootScope.unauthenticatedHandle = $rootScope.$on('unauthenticated', function (event, doLogout, error) {
            if (doLogout) {
                $state.go('login');
                if (error) {
                    toast.showError(error, null, 'bottom right');
                }
            } else {
                UrlHandler($injector, $location);
            }
        });

        $rootScope.authenticatedHandle = $rootScope.$on('authenticated', function () {
            UrlHandler($injector, $location);
        });

        $rootScope.forbiddenHandle = $rootScope.$on('forbidden', function () {
            showForbiddenDialog();
        });

        $rootScope.stateChangeStartHandle = $rootScope.$on('$stateChangeStart', function (evt, to, params) {

            function waitForUserLoaded() {
                if ($rootScope.userLoadedHandle) {
                    $rootScope.userLoadedHandle();
                }
                $rootScope.userLoadedHandle = $rootScope.$on('userLoaded', function () {
                    $rootScope.userLoadedHandle();
                    $state.go(to.name, params);
                });
            }
            toast.hide();

            var locationSearch = $location.search();
            var activateToken = locationSearch.activateToken;

            if (to.url === '/createPassword?activateToken' && activateToken && activateToken.length) {
                userService.setUserFromJwtToken(null, null, false, false, false, null, activateToken);
            }

            if (userService.isUserLoaded() === true) {
                if (userService.isAuthenticated()) {
                    if (userService.forceDefaultPlace(to, params)) {
                        evt.preventDefault();
                        gotoDefaultPlace(params);
                    } else {
                        var authority = userService.getAuthority();
                        if (to.module === 'public') {
                            evt.preventDefault();
                            gotoDefaultPlace(params);
                        } else if (angular.isDefined(to.auth) &&
                            to.auth.indexOf(authority) === -1) {
                            evt.preventDefault();
                            showForbiddenDialog();
                        } else if (to.redirectTo) {
                            evt.preventDefault();
                            $state.go(to.redirectTo, params)
                        }
                    }
                } else {
                    if (to.module === 'private') {
                        evt.preventDefault();
                        if (to.url === '/home' || to.url === '/') {
                            $state.go('login', params);
                        } else {
                            showUnauthorizedDialog();
                        }
                    }
                }
            } else {
                evt.preventDefault();
                waitForUserLoaded();
            }
        })

        $rootScope.pageTitle = 'Tektelic OAM';

        $rootScope.stateChangeSuccessHandle = $rootScope.$on('$stateChangeSuccess', function (evt, to) {
            if (angular.isDefined(to.data.pageTitle)) {
                $translate(to.data.pageTitle).then(function (translation) {
                    $rootScope.pageTitle = 'Tektelic OAM | ' + translation;
                }, function (translationId) {
                    $rootScope.pageTitle = 'Tektelic OAM | ' + translationId;
                });
            }

            if (to.url === '/dashboard' || to.url === '/gateways' || to.url === '/:gatewayGroupId/gateways') {
                startIntervalTokenRefresh();
            } else {
                stopIntervalTokenRefresh();
            }
        })

         $rootScope.destroyHandle = $rootScope.$on('$destroy', stopIntervalTokenRefresh);
    }

    function gotoDefaultPlace(params) {
        userService.gotoDefaultPlace(params);
    }

    function showUnauthorizedDialog() {
        if (unauthorizedDialog === null) {
            $translate(['access.unauthorized-access',
                        'access.unauthorized-access-text',
                        'access.unauthorized',
                        'action.cancel',
                        'action.sign-in']).then(function (translations) {
                if (unauthorizedDialog === null) {
                    unauthorizedDialog = $mdDialog.confirm()
                        .title(translations['access.unauthorized-access'])
                        .textContent(translations['access.unauthorized-access-text'])
                        .ariaLabel(translations['access.unauthorized'])
                        .cancel(translations['action.cancel'])
                        .ok(translations['action.sign-in']);
                    $mdDialog.show(unauthorizedDialog).then(function () {
                        unauthorizedDialog = null;
                        $state.go('login');
                    }, function () {
                        unauthorizedDialog = null;
                    });
                }
            });
        }
    }

    function showForbiddenDialog() {
        if (forbiddenDialog === null) {
            $translate(['access.access-forbidden',
                'access.access-forbidden-text',
                'access.access-forbidden',
                'action.cancel',
                'action.sign-in']).then(function (translations) {
                if (forbiddenDialog === null) {
                    forbiddenDialog = $mdDialog.confirm()
                        .title(translations['access.access-forbidden'])
                        .htmlContent(translations['access.access-forbidden-text'])
                        .ariaLabel(translations['access.access-forbidden'])
                        .cancel(translations['action.cancel'])
                        .ok(translations['action.sign-in']);
                    $mdDialog.show(forbiddenDialog).then(function () {
                        forbiddenDialog = null;
                        userService.logout();
                    }, function () {
                        forbiddenDialog = null;
                    });
                }
            });
        }
    }

    function startIntervalTokenRefresh() {
        if (!refreshInterval) {
            const refreshFn = () => {
                userService.validateJwtToken(true, TOKEN_BUFFER_MS)
                    .catch(err => {
                        $log.error('Token refresh failed:', err);
                        stopIntervalTokenRefresh();
                    });
            };

            refreshFn();
            refreshInterval = $interval(refreshFn, REFRESH_INTERVAL);
        }
    }

    function stopIntervalTokenRefresh() {
        if (refreshInterval) {
            $interval.cancel(refreshInterval);
            refreshInterval = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.run.js